import firebase from "firebase"
  const config = {
    apiKey: "AIzaSyBF1nUZrvs9WgXLUk3uiA1vOlFuGuFFxzI",
    authDomain: "redslon.firebaseapp.com",
    databaseURL: "https://redslon.firebaseio.com",
    projectId: "redslon",
    storageBucket: "redslon.appspot.com",
    messagingSenderId: "216271771263",
   
  };
  // Initialize Firebase
 const fire= firebase.initializeApp(config);
 const facebookProvider=new firebase.auth.FacebookAuthProvider()
export {fire,facebookProvider}